module.exports = __webpack_public_path__ + "static/media/foodIcon.0217c6ed.png";